/* eslint-disable react/destructuring-assignment */
import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import SVGClose from '@Assets/SVG/Close'
import { Link } from '@Components/Link'
import { ProductContext } from '@Components/Product/Context'
import { ControllerContext } from '@Components/Product/Slider/Context/ControllerContext'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import { AddToWishList } from '@Components/WishList/addToWishList'
import { Button } from '@CoreComponents/Buttons/Button'
import SliderControls from '@Domains/Product/Features/Display/SliderControls/SliderControls'
import SliderProgress from '@Domains/Product/Features/Display/SliderProgress/SliderProgress'
import { PagePresentation, PageType } from '@Generated/graphql'
import { CMSModalContext } from '@Globals/CMS/Modal/Context'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { useTranslation } from '@Globals/Translations'

import AiTag from './AiTag/AiTag'
import styles from './SliderOverlay.module.scss'

const SliderOverlay: FC = () => {
  const { t } = useTranslation()
  const product = useContext(ProductContext)
  const {
    isZoomedIn,
    setZoomedIn,
  } = useContext(ControllerContext)
  const {
    activeSlide,
    isFullscreen,
    isSwipedUp,
    slides,
    toggleFullscreen,
  } = useContext(SliderContext)
  const [, openModal] = useContext(CMSModalContext)

  if (!product) {
    return null
  }

  const videoKey = slides.findIndex(slide => slide.tags?.includes('video'))
  const activeTags = slides[activeSlide.key]?.tags || []
  const activeLookID = activeTags.find(tag => tag.startsWith('look:'))?.replace('look:', '') || ''
  const isAiModelSlide = activeTags.includes('ai') && activeTags.includes('model')

  return (
    <>
      <div
        className={clsx(
          styles.actions,
          activeSlide.key === videoKey && styles.hidden,
          isFullscreen && styles.fullscreen,
        )}
      >
        {isZoomedIn && (
          <Button
            className={clsx(styles.action, styles.exitZoom)}
            onClick={() => setZoomedIn(false)}
            theme="white"
            type="button"
          >
            {t('common:ZOOM_OUT')}
          </Button>
        )}

        {!isSwipedUp && isFullscreen && (
          <button
            className={clsx(styles.action, styles.closeButton)}
            onClick={toggleFullscreen}
            type="button"
          >
            {' '}
            <SVGClose />
          </button>
        )}

        <div className={clsx(styles.action, styles.wishListContainer)}>
          <AddToWishList className={styles.wishlistButton} id={product.id} />
        </div>

        {isAiModelSlide && (
          <Experiment
            b={<AiTag className={styles.aiTag} />}
            test="ai_tag_v1"
          />
        )}

        {activeLookID && (
          <Button
            className={clsx(styles.action, styles.lookButton)}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              openModal(PageType.Look, activeLookID, 'product_display_gallery', PagePresentation.Sidebar)
            }}
            onDoubleClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
            }}
            theme="white"
            type="button"
          >
            {t('common:SHOP_THE_LOOK')}
          </Button>
        )}
      </div>

      {product.brand && (
        <Link className={styles.brand} href={product.brand.url?.toString()}>
          <img
            alt={product.brand.id || ''}
            src={product.brand.logo || ''}
            title={product.brand.title || ''}
          />
        </Link>
      )}

      <SliderControls />
      {slides.length < 3 && (
        <SliderProgress />
      )}
    </>
  )
}

export default SliderOverlay
